import { render } from "./RegistrationsOverview.vue?vue&type=template&id=0296deeb&scoped=true&ts=true"
import script from "./RegistrationsOverview.vue?vue&type=script&lang=ts"
export * from "./RegistrationsOverview.vue?vue&type=script&lang=ts"

import "./RegistrationsOverview.vue?vue&type=style&index=0&id=0296deeb&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0296deeb"]])

export default __exports__